import React, { ChangeEventHandler } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  MenuItem,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import { Option } from "~/types/component";

type OutlineSelectProps = {
  label?: string;
  value: unknown;
  onChange?: ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;
  error?: boolean;
  helperText?: string;
  options: Option[];
  required?: boolean;
  marginBottom?: number;
  width?: string | number;
  isNumbering?: boolean;
  variant?: "filled" | "outlined" | "standard";
};

export const OutlineSelect: React.VFC<OutlineSelectProps> = (props) => {
  // styles
  const useStyles = makeStyles({
    textField: {
      display: "block",
      margin: "auto",
      marginTop: 10,
      marginBottom: props.marginBottom ?? 30,
      width: props.width ?? "60%",
    },
  });
  const classes = useStyles();

  const _options: Option[] =
    props.required === true
      ? props.options
      : props.options.concat({ label: "回答しない" });

  return (
    <div className={classes.textField}>
      <TextField
        label={props.label}
        value={props.value !== undefined ? props.value : null}
        onChange={props.onChange}
        error={props.error}
        helperText={props.helperText}
        variant={props.variant ?? "outlined"}
        select
        fullWidth
      >
        {_options.map((option) => {
          let label = option.label;
          if (option.value !== undefined && props.isNumbering === true) {
            label = `${option.value}: ${option.label}`;
          }
          return (
            <MenuItem key={option.label} value={option.value}>
              {label}
            </MenuItem>
          );
        })}
      </TextField>
    </div>
  );
};

type RadioSelectProps = {
  label: string;
  value: unknown;
  onChange?: ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;
  options: Option[];
  marginBottom?: number;
  width?: string | number;
};

export const RadioSelect: React.VFC<RadioSelectProps> = (props) => {
  // styles
  const useStyles = makeStyles({
    wrapper: {
      display: "block",
      margin: "auto",
      marginTop: 10,
      marginBottom: props.marginBottom ?? 30,
      width: props.width ?? "60%",
      minWidth: 300,
    },
    radioGroup: {
      display: "flex",
      flexDirection: "row",
      marginTop: 5,
    },
    radio: {
      marginRight: 30,
    },
  });
  const classes = useStyles();

  return (
    <FormControl classes={{ root: classes.wrapper }} component="fieldset">
      <FormLabel component="legend">{props.label}</FormLabel>
      <RadioGroup
        classes={{ root: classes.radioGroup }}
        value={props.value}
        onChange={props.onChange}
      >
        {props.options.map((option, index) => {
          return (
            <FormControlLabel
              key={`option_${option.label}_${index}`}
              classes={{ root: classes.radio }}
              value={option.value}
              control={<Radio />}
              label={option.label}
            />
          );
        })}
      </RadioGroup>
    </FormControl>
  );
};
